import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// routes
import { ToastContainer } from 'material-react-toastify';
import secureLocalStorage from 'react-secure-storage';
import RouterConfig from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import { AuthProvider } from './context/AuthContext';
import './App.css';
// ----------------------------------------------------------------------

export default function App() {
  const [t, i18n] = useTranslation();

  useEffect(() => {
    if (localStorage.getItem('lang') === 'العربية') {
      i18n.changeLanguage('ar');
      document.body.setAttribute('dir', 'rtl');
    } else {
      i18n.changeLanguage('fr');
      document.body.setAttribute('dir', 'ltr');
    }
  }, []);
  return (
    <div className="app">
      <ThemeConfig>
        <AuthProvider>
          <ScrollToTop />
          <GlobalStyles />
          <BaseOptionChartStyle />
          <RouterConfig />
          <ToastContainer />
        </AuthProvider>
      </ThemeConfig>
    </div>
  );
}
